import { getUbbConfig } from '#pplx/frontend/apps/ask/queries/billing-queries/ubb-config/getUbbConfig.js';
import { getUbbConfigQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/billingKeys.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
export const useGetUbbConfig = () => {
    return useQuery({
        queryKey: getUbbConfigQueryKey(),
        queryFn: getUbbConfig,
        // Catalog is near-static (changes only on an Eppo flag edit); cache long
        // and skip focus refetch so credits/paywall renders don't re-fetch it.
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
    });
};
//# sourceMappingURL=useGetUbbConfig.js.map